<template>
  <v-card>
    <v-card-text class="px-0">
      <v-data-table
        :headers="headers"
        :items="subscriptions"
        :pagination.sync="pagination"
        :total-items="total"
        :rowsPerPageItems="rowsPerPageItems"
        item-key="id"
        :loading="loading"
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.stripeSubscription.metadata.email }}</td>
            <!-- <td>{{ props.item.stripeSubscription.plan.metadata.plan_name }}</td> -->
            <td>{{ props.item.stripeSubscription.plan.metadata.plan_name }}</td>
            <td>{{getCurrencySymbol(props.item.stripeSubscription.plan.currency)}}{{ props.item.stripeSubscription.plan.amount/100 }}</td>
            <td>
              <b>
                <span v-if="props.item.stripeSubscription.status === 'active'" class="success--text">{{ props.item.stripeSubscription.status | capitalize }}</span>
                <span v-else>{{ props.item.stripeSubscription.status | capitalize }}</span>
              </b>
            </td>
            <td>
              {{
                moment
                  .utc(props.item.created_at)
                  .local()
                  .format("Do MMM YYYY, h:mm a")
              }}
            </td>
          </tr>
        </template>
        </v-data-table> 
    </v-card-text>
  </v-card>
</template>

<script>
import { getCurrencySymbol } from "@/helper";
export default {
  name: "SubscriptionList",
  data() {
    return {
      subscriptions: [],
      headers: [
        {
          text: "S.No.",
          align: "left",
          sortable: false,
          value: "number",
        },
        {
          text: "Subscription",
          align: "left",
          sortable: false,
          value: "customer",
        },
        {
          text: "Plan",
          align: "left",
          sortable: false,
          value: "pricing_type",
        },
        {
          text:"Price",
          align: "left",
          sortable: false,
          value: "screener_title",
        },
        {
          text: "Status",
          align: "left",
          sortable: false,
          value: "status",
        },
        {
          text: "Created At",
          align: "left",
          sortable: true,
          value: "created_at",
        },
      ],
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "created_at",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      search: "",
      loading: false,
      total: null,
    };
  },
  created() {
    this.listSubscriptionFromApi();
  },
  watch: {
    pagination: {
      handler: "listSubscriptionFromApi",
      deep: true,
    },
  },
  methods: {
    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
    viewReceipt(receipt_url) {
      if (receipt_url) {
        window.open(receipt_url);
      }
    },
    getCurrencySymbol(currency) {
      return getCurrencySymbol(currency);
    },
    async listSubscriptionFromApi() {
      try {
        console.log('Getting subscriptions from API...');
        this.loading = true;
        // Pagination
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        var offset = this.getPaginationOffset(rowsPerPage, page);
        // Payload
        let payload = {
          offset: offset,
          limit: rowsPerPage,
          sort: sortBy,
          sorting_order: descending,
          search: this.search,
          filters: {},
        };
        var response = await this.$store.dispatch("company/listSubscription", payload);
        this.subscriptions = response.subscriptions.data;
        this.total = response.subscriptions.total;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }finally{
        this.loading = false;
      }
    },
  },
};
</script>

<style>

</style>